import { useTranslations } from "next-intl";
import { useId, useState } from "react";
import "./index.scss";

const SelectRate = ({
  customerGroup,
  couponCode,
  onChangeRate,
  customerGroups = [],
  displayPromotionCode = false,
}: {
  customerGroup: string;
  couponCode: string;
  onChangeRate: (customerGroup: string, couponCode: string) => void;
  customerGroups: string[];
  displayPromotionCode: boolean;
}) => {
  const t = useTranslations("CheckAvailability");

  const [isPromotionCodeEnabled, setIsPromotionCodeEnabled] = useState(
    !!couponCode && couponCode.length > 0
  );
  const id = useId();

  const customerGroupRadioOptions = customerGroups.map(
    (customerGroupOption, customerGroupOptionIndex) => {
      return (
        <div className="radio-option" key={customerGroupOption}>
          <input
            type="radio"
            name="customerGroup"
            checked={
              customerGroup === customerGroupOption &&
              isPromotionCodeEnabled === false
            }
            onChange={() => {
              setIsPromotionCodeEnabled(false);
              onChangeRate(customerGroupOption, "");
            }}
          />
          <label>{customerGroupOption}</label>
        </div>
      );
    }
  );

  return (
    <div className="component select-rate">
      <div className="select-rate-inner-wrapper">
        <div className="radio-options">
          <div className="radio-option">
            <input
              type="radio"
              name="customerGroup"
              checked={customerGroup === "" && isPromotionCodeEnabled === false}
              onChange={() => {
                setIsPromotionCodeEnabled(false);
                onChangeRate("", "");
              }}
            />
            <label>{t("best-available-rate")}</label>
          </div>
          {customerGroupRadioOptions}
          {displayPromotionCode && (
            <div className="radio-option">
              <input
                type="radio"
                name="customerGroup"
                checked={isPromotionCodeEnabled}
                onChange={() => {
                  onChangeRate("", couponCode);
                  setIsPromotionCodeEnabled(true);
                }}
              />
              <label>{t("promotion-code")}</label>
            </div>
          )}
        </div>

        {isPromotionCodeEnabled && (
          <div className="promotion-code">
            <label htmlFor={`promotion-code-${id}`}>
              {t("promotion-code")}
            </label>
            <input
              type="text"
              id={`promotion-code-${id}`}
              value={couponCode}
              onChange={(e) => {
                onChangeRate("", e.target.value);
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectRate;
